import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaUser, FaUserTie } from 'react-icons/fa';
import { Button, Fab, Grid, Paper, Tooltip, Typography } from "@mui/material";
import PrintIcon from '@mui/icons-material/Print';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PublicIcon from '@mui/icons-material/Public';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UpdateIcon from '@mui/icons-material/Update';
import SearchIcon from '@mui/icons-material/Search';
import Templete from "../../template/Template";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import SnackBar, { SnackMessageProps } from "../../components/SnackBar/SnackBar";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api, apiUrl, comunicaapiUrl } from "../../services/api";

import HistoricoProcesso from "../../modals/processos/HistoricoProcesso";
import NewConsult from "./NewConsult";
import ModalConsultProcesso from "./ModalConsultProcesso";
import { consultProcessosDJEN } from "./ConsutlProcessosDJEN";

type DestinatariosConsult = {
    nome: string
}

type AdvConsult = {
    advogado: DestinatariosConsult
}

type ResConsult = {
    data_disponibilizacao: Date | null | string
    datadisponibilizacao: string
    hash: string
    id: string
    link: string
    meiocompleto: string
    nomeClasse: string
    nomeOrgao: string
    numero_processo: string
    numeroprocessocommascara: string
    siglaTribunal: string
    texto: string
    tipoComunicacao: string
    destinatarios: DestinatariosConsult[]
    destinatarioadvogados: AdvConsult[]

}

export default function Consultas() {
    const navigate = useNavigate();
    const [searchParms] = useSearchParams();
    const [load, setLoad] = useState(false);
    const [openNewBusca, setOpenNewBusca] = useState(false);
    const [openModalProcess, setOpenModalProcess] = useState(false);
    const [openHistroy, setOpenHistory] = useState(false);
    const [snack, setSnack] = useState<SnackMessageProps>({ open: false, text: '', color: "success" });
    const [results, setResults] = useState<ResConsult[]>([]);
    const [arrHistory, setArrHistory] = useState([]);

    async function existProcessProtocolo(protocol: string) {
        setLoad(true);
        let res = null;
        try {
            const response = await api.get(`/processo/${protocol}`);
            console.log(response);
            if (response && response.status === 200 && response.data) {
                if (response.data.error) {
                    AlertInfo({ icon: 'error', title: response.data.message });
                } else if (response.data.id_processo) {
                    res = response.data.id_processo;
                } else {
                    AlertInfo({ icon: 'error', title: 'Numero do processo não localizado no sistema' });
                }
            } else {
                AlertInfo({ icon: 'error', title: 'Numero do processo não localizado no sistema' });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: "error", title: 'Falha na conexão' });
        }
        setLoad(false);
        return res;
    }

    function handleCopy(txt: string) {
        navigator.clipboard.writeText(txt);
        setSnack({ open: true, text: "Texto Copiado!", color: "success" });
    }

    async function viewProcess(protocolo_processo: string) {
        const id = await existProcessProtocolo(protocolo_processo);
        if (id) {
            navigate(`/consultas?id=${id}`);
            setOpenModalProcess(true);
        }
    }

    async function openHistoryStatus(protocol: string) {
        const id = await existProcessProtocolo(protocol);
        if (id) {
            setLoad(true);
            try {
                const response = await api.get(`/eventosproceso/${id}`);
                if (response.status === 200 && response.data) {
                    if (response.data.error) {
                        AlertInfo({ icon: 'error', title: response.data.message });
                    } else {
                        setArrHistory(response.data);
                        setOpenHistory(true);
                    }
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: 'error', title: 'Falha na conexão' });
            }
            setLoad(false);
        }
    }

    async function loadConsult() {
        const protocolo_processo = searchParms.get('protocolo');
        if (protocolo_processo) {
            setLoad(true);
            try {
                const dataBusca = { busca: "2", protocolo_processo, dataInicial: null, dataFinal: null, advogados: [] };
                // const response = await api.post(`/consultapje`, dataBusca);
                const response = await consultProcessosDJEN(dataBusca);
                if (response.error) {
                    AlertInfo({ icon: 'error', title: response.msg });
                } else if (response) {
                    setResults(response);
                    setSnack({ open: true, text: `${response.length} Resultados Encontrados`, color: 'success' });
                }
            } catch (error) {
                console.log(error);
                AlertInfo({ icon: "error", title: 'NÃO POSSIVEL BUSCAR DADOS' });
            }
            setLoad(false);
        }
    }

    useEffect(() => {
        loadConsult();
    }, [searchParms]);

    return (
        <Templete menuActive="consultas">
            <NewConsult
                open={openNewBusca}
                setOpen={setOpenNewBusca}
                restResults={setResults}
                setSnack={setSnack}
            />
            <ModalConsultProcesso
                open={openModalProcess}
                setOpen={setOpenModalProcess}
            />
            <SnackBar
                value={snack}
                setValue={setSnack}
            />
            <SimpleBackdrop open={load} />

            <HistoricoProcesso
                open={openHistroy}
                setOpen={setOpenHistory}
                historico={arrHistory}
            />

            <Grid container spacing={1}>
                <Grid item xs={12} container justifyContent="flex-end">
                    <Button
                        variant="contained"
                        startIcon={<SearchIcon />}
                        onClick={() => setOpenNewBusca(true)}
                    >
                        NOVA CONSULTA
                    </Button>
                </Grid>

                {results.map((res, index) => (
                    <Grid item xs={12} key={index}>
                        <Paper elevation={24} sx={{ p: 2, m: 2 }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sx={{ borderBottom: '1px solid #ccc' }}>
                                    <Typography variant="h6" color="InfoText" sx={{ fontWeight: 'bold' }} textAlign="center">
                                        Processo N° {res.numeroprocessocommascara}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body1" mb={1}>
                                        <Typography component="span" sx={{ fontWeight: 'bold' }}>Órgão:</Typography> {res.nomeOrgao}
                                    </Typography>
                                    <Typography variant="body1" mb={1}>
                                        <Typography component="span" sx={{ fontWeight: 'bold' }}>Data de disponibilização:</Typography> {res.datadisponibilizacao}
                                    </Typography>
                                    <Typography variant="body1" mb={1}>
                                        <Typography component="span" sx={{ fontWeight: 'bold' }}>Tipo de comunicação:</Typography> {res.tipoComunicacao}
                                    </Typography>
                                    <Typography variant="body1" mb={1}>
                                        <Typography component="span" sx={{ fontWeight: 'bold' }}>Meio:</Typography> {res.meiocompleto}
                                    </Typography>
                                    <Typography variant="body1" mb={1}>
                                        <Typography component="span" sx={{ fontWeight: 'bold' }}>Classe:</Typography> {res.nomeClasse}
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Parte(s):</Typography>
                                    {res.destinatarios.map((des, index) => (
                                        <Typography key={`des${index}`} variant="body1" sx={{ fontWeight: 'bold' }}>
                                            <FaUser style={{ marginRight: 5 }} />{des.nome}
                                        </Typography>
                                    ))}
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Advogado(s):</Typography>
                                    {res.destinatarioadvogados.map((adv, index) => (
                                        <Typography key={`adv${index}`} variant="body1" sx={{ fontWeight: 'bold' }}>
                                            <FaUserTie style={{ marginRight: 5 }} />{adv.advogado.nome}
                                        </Typography>
                                    ))}
                                </Grid>

                                <Grid item xs={12} sm={8} sx={{ overflowY: 'scroll', height: 420, borderLeft: '1px solid #ccc' }}>
                                    <Typography variant="body1" mb={1}>
                                        {res.texto}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} container justifyContent="center" gap={2}>
                                    <Tooltip title="IMPRIMIR">
                                        <Fab color="primary" aria-label="add" onClick={() => window.open(comunicaapiUrl + `/comunicacao/${res.hash}/certidao`)}>
                                            <PrintIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="COPIAR TEXTO">
                                        <Fab color="primary" aria-label="add" onClick={() => handleCopy(res.texto)}>
                                            <ContentCopyIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="ACESSAR PELO PJE">
                                        <Fab color="primary" aria-label="add" onClick={() => window.open(res.link)}>
                                            <PublicIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="VISUALIZAR PROCESSO">
                                        <Fab color="primary" aria-label="add" onClick={() => viewProcess(res.numero_processo)}>
                                            <VisibilityIcon />
                                        </Fab>
                                    </Tooltip>
                                    <Tooltip title="HISTORICO PROCESSO" onClick={() => openHistoryStatus(res.numero_processo)}>
                                        <Fab color="primary" aria-label="add">
                                            <UpdateIcon />
                                        </Fab>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                ))}

                {results.length === 0 && (
                    <Grid item xs={12} container spacing={1} justifyContent="center" direction="column" alignItems="center">
                        <br />
                        <img src={`${apiUrl}/svg/text_files`} alt="Consulta" width={350}></img>
                    </Grid>
                )}

            </Grid>
        </Templete>
    );
}